import React from "react"
import { Box } from "@chakra-ui/react"
import Image from "next/image"
import { Link } from "components/Link"
import type { ItemType } from "types"

interface Props {
  item: ItemType
  pdpUrl?: string
  src?: string
  alt?: string
  imgWidth?: string
  imgHeight?: string
  title?: string
}

const unoptimized =
  process.env.STORYBOOK === "true" || process.env.NODE_ENV === "test"

const CartImageWrapper: React.FC<Omit<Props, "pdpUrl">> = ({
  item,
  src,
  alt,
  imgWidth = "90px",
  imgHeight = "120px",
  title,
}) => {
  const firstMedia = item?.variant?.detailsMedia ?? item?.variant?.media?.[0]

  const imageUrl = src || firstMedia?.thumbnails?.size_240
  const imageAlt = alt || firstMedia?.description || "Beautypie Product"

  const imageTitle = title || firstMedia?.description || "Beautypie Product"

  if (!imageUrl) {
    return null
  }

  return (
    <Box
      width={imgWidth}
      position="relative"
      height={imgHeight}
      css={{
        "@media (max-width: 320px)": {
          width: "5.1875rem",
        },
      }}
    >
      <Image
        src={imageUrl}
        alt={imageAlt}
        unoptimized={unoptimized}
        title={imageTitle}
        fill
        sizes="(max-width: 768px) 5.6rem, (max-width: 1200px) 6rem"
        style={{
          objectFit: "contain",
        }}
      />
    </Box>
  )
}

export const CardImage: React.FC<Props> = ({ pdpUrl, ...rest }) => {
  if (!pdpUrl) {
    return <CartImageWrapper {...rest} />
  }

  return (
    <Link href={pdpUrl}>
      <CartImageWrapper {...rest} />
    </Link>
  )
}
